// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"90227cb2","88":"a501b298","236":"19ce8720","346":"392e5f77","404":"369cc23c","450":"d574bb6f","453":"bbe7f55d","590":"3bbb68b8","609":"3abb585b","641":"f264381f","664":"3434def3","775":"1bfe4986","804":"5fe9cca0"}[chunkId] + ".chunk.js";
};